<template>
  <Dialog
    title="Upload Production Files"
    :show-close-button="true"
    @close-event="handleClose"
    :show-footer="true"
    :custom-footer="true"
    sm
  >
    <template #modal-content>
      <div class="d-flex justify-content-between gap-2 py-4 px-3 m-auto">
        <!-- <pre>{{ activity_navigation_index }}</pre> -->
        <!-- <pre>{{ activity_items }}</pre> -->

        <div
          style="width: 100%"
          v-for="(actFile, fileInd) in activity_items.activity_item_data[activity_navigation_index]
            ?.files"
          :key="`actfile-${fileInd}`"
        >
          <div class="fs-2">
            <strong>{{ actFile.side.toUpperCase() }}</strong>
          </div>

          <label class="upload-box relative">
            <button
              v-if="actFile.file"
              @click="deleteFile(activity_navigation_index, fileInd)"
              class="absolute top-0 right-0 p-1 text-red-500 hover:text-red-700"
            >
              <XCircleIcon class="size-7" />
            </button>
            <template v-if="actFile.file">
              <template
                v-if="
                  ['jpg', 'jpeg', 'png', 'bmp'].includes(
                    getFileExtension(
                      activity_items.activity_item_data[activity_navigation_index].files[fileInd]
                        .file.name
                    )
                  )
                "
              >
                <div class="uploaded-logo-holder">
                  <img
                    :src="setSampleImage(activity_navigation_index, fileInd)"
                    style="width: 100%; max-width: 350px"
                  />
                </div>
              </template>
              <template v-else>
                <button class="btn btn-secondary" style="width: 100%; height: 100%">
                  <b-icon-file-earmark style="width: 100%; height: 100%" />
                </button>
              </template>
            </template>
            <input
              v-if="!actFile.file"
              type="file"
              @change="
                changeSampleFile(
                  ($event.target as HTMLInputElement).files,
                  activity_navigation_index,
                  fileInd
                )
              "
              placeholder="upload sample file"
              style="margin-top: 5px"
            />
          </label>

          <div class="upload-box mt-1">
            <div class="uploaded-logo-holder">
              <img
                :src="`${storage_url}/${activity_items.activity_item_data[activity_navigation_index].product_files[fileInd]}`"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- Footer Slot -->
    <template #footer>
      <div class="flex justify-end flex-wrap gap-2">
        <button class="px-4 py-2 bg-surface-3 text-ink rounded" @click="handleCancel">
          Cancel
        </button>

        <template v-if="activity_navigation_index > 0">
          <button
            class="px-4 py-2 bg-surface-3 text-white rounded"
            @click="navigateSampleFiles('back')"
          >
            Previous
          </button>
        </template>

        <template
          v-if="
            Array.isArray(activity_items.activity_item_data) &&
            activity_items.activity_item_data.length - 1 === activity_navigation_index
          "
        >
          <button class="px-4 py-2 bg-surface-3 text-white rounded" @click="submitSampleFiles">
            Upload Files
          </button>
        </template>

        <template
          v-else-if="
            Array.isArray(activity_items.activity_item_data) && activity_items.activity_item_data
          "
        >
          <button
            class="px-4 py-2 bg-surface-3 text-white rsounded"
            @click="navigateSampleFiles('next')"
          >
            Next
          </button>
        </template>
      </div>
    </template>
  </Dialog>
</template>
<script setup lang="ts">
import Dialog from '@/components/Shared/Dialog.vue';
import { getFileExtension, storage_url } from '@/composables/index';
import { ActivityItemPayload } from '@/models';
import { XCircleIcon } from '@heroicons/vue/24/solid';
import { onMounted } from 'vue';
interface Props {
  activity_items: ActivityItemPayload;
  activity_navigation_index: number;
}
const props = defineProps<Props>();

const emits = defineEmits([
  'close',
  'cancel',
  'skip-sample-approval',
  'navigate-sample-files',
  'submit-sample-files',
  'change-sample-file',
  'delete-file',
  'close-message',
  'update-reason',
]);

const handleClose = () => {
  emits('close');
};
const handleCancel = () => {
  emits('cancel');
};
const skipSampleApproval = (data, index) => {
  emits('skip-sample-approval', data, index);
};
const navigateSampleFiles = (direction) => {
  emits('navigate-sample-files', direction);
};
const submitSampleFiles = () => {
  emits('submit-sample-files');
};
const changeSampleFile = (files, navIndex, fileInd) => {
  emits('change-sample-file', files, navIndex, fileInd);
};
const deleteFile = (navIndex, fileInd) => {
  emits('delete-file', navIndex, fileInd);
};
const closeMessage = (data, navIndex) => {
  emits('close-message', data, navIndex);
};
const updateReason = (data, navIndex) => {
  emits('update-reason', data, navIndex);
};
const setSampleImage = (act_item_index, file_index) => {
  return URL.createObjectURL(
    props.activity_items.activity_item_data[act_item_index].files[file_index].file
  );
};
</script>
<style lang="scss" scoped>
.upload-box {
  width: 100%;

  .uploaded-logo-holder {
    border-radius: 5px;
    overflow: hidden;
    border: 1px solid #ddd;
    height: 300px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      max-width: 100% !important;
      max-height: 100% !important;
      width: auto !important;
      height: auto !important;
    }
  }
}
</style>
